import {useLayoutEffect, useState} from 'react';

const headerHeight = () => document.getElementById('header')?.clientHeight ?? 64;

export default function useHeaderHeight() {
    const [height, setHeight] = useState(headerHeight);
    useLayoutEffect(() => {
        const header = document.getElementById('header');
        if(!header) return;
        const measure = () => setHeight(header.clientHeight);
        measure();
        if(window.ResizeObserver) {
            const observer = new ResizeObserver(measure);
            observer.observe(header);
            return () => observer.disconnect();
        }
        let frame;
        const resized = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(measure);
        };
        window.addEventListener('resize', resized);
        return () => {
            window.removeEventListener('resize', resized);
            cancelAnimationFrame(frame);
        };
    }, []);
    return height;
}
